module.exports = __webpack_public_path__ + "img/39.4682bbde.jpg";